import React from 'react'
import { getFileSizeMB } from '../../../helpers/file/FileHelper'

const FileUploadedItem = ({ file, item }) => {
  return (
    <div>
        <p>{item}</p>
        <p>{file.name}</p>
        <p> ({getFileSizeMB({ size: file.size })})</p>
    </div>
  )
}

export default FileUploadedItem